
import React from 'react';
import Layout from '@/components/Layout/Layout';
import AgeCalculator from '@/components/SpecialCalculators/HealthCalculators/AgeCalculator';

const AgeCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Age Calculator</h1>
        <p className="text-gray-600 mb-8">
          Calculate exact age between two dates in years, months, and days.
        </p>
        
        <AgeCalculator />
        
        <div className="mt-12 p-6 bg-blue-50 rounded-lg">
          <h2 className="text-xl font-bold mb-2">About Age Calculator</h2>
          <p className="text-gray-700 mb-4">
            This age calculator helps you determine the exact age between two dates,
            broken down into years, months, and days. It's perfect for calculating:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li>Your exact age today</li>
            <li>Age at a specific past or future date</li>
            <li>Time elapsed between any two dates</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default AgeCalculatorPage;
